import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation, useQueryClient } from 'react-query';
import { quickVideoKeys } from './quickVideoKeys';
import { useToastError } from 'lib/hooks';
import { successToast } from 'lib/components/toasts/success';
import { useTranslation } from 'react-i18next';

type DeleteBatchData = {
  quickVideoIds: number[];
};

const deleteBatchQuickVideo = async ({ quickVideoIds }: DeleteBatchData) => {
  return (
    await EXPRESS_API.delete('quick-videos', {
      data: quickVideoIds,
    })
  ).data;
};

type DeleteBatchParams = {
  onSuccess?: () => void;
};

export const useDeleteBatchQuickVideoMutation = ({
  onSuccess,
}: DeleteBatchParams) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { showError } = useToastError();
  return useMutation(deleteBatchQuickVideo, {
    onSuccess: () => {
      successToast({ title: t('Quick Videos successfully deleted.') });
      if (onSuccess) {
        onSuccess();
      }
      queryClient.invalidateQueries(quickVideoKeys.all());
    },
    onError: err => {
      showError(err);
    },
  });
};
